import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import ActionsAPI from 'services/ActionsAPI'

const RemedialsReviewEntry = ({ bpId = null }) => {
  const navigate = useNavigate()
  const [total, setTotal] = useState(null)
  const [oldCount, setOldCount] = useState(0)

  useEffect(() => {
    let cancelled = false
    ActionsAPI.list({
      'filter[status]': 'pending_review',
      'filter[source]': 'guru',
      ...(bpId ? { 'filter[building_passport_id]': bpId } : {}),
      per_page: 1,
    })
      .then(res => { if (!cancelled) setTotal(res.data?.meta?.total ?? 0) })
      .catch(() => { if (!cancelled) setTotal(0) })
    ActionsAPI.cleanupPreview({ olderThan: '1y', ...(bpId ? { buildingPassportId: bpId } : {}) })
      .then(res => { if (!cancelled) setOldCount(res?.data?.data?.suggestions || 0) })
      .catch(() => {})
    return () => { cancelled = true }
  }, [bpId])

  if (!total) return null

  const to = bpId ? `/bp-list/${bpId}/remedials/review` : '/actions/review'

  return (
    <Banner onClick={() => navigate(to)}>
      <IconTile><AutoAwesomeRoundedIcon style={{ fontSize: 20 }} /></IconTile>
      <Text>
        <Title>{total.toLocaleString('en-GB')} possible problem{total > 1 ? 's' : ''} found in your documents need checking</Title>
        <Sub>
          Our AI spotted these in your uploaded documents. They do not count as remedials until someone checks them:
          approve the real ones and remove the rest.
          {oldCount > 0 && ` ${oldCount.toLocaleString('en-GB')} come from documents uploaded more than a year ago, which you can clear in one go.`}
        </Sub>
      </Text>
      <Go>Check them <ArrowForwardRoundedIcon style={{ fontSize: 18 }} /></Go>
    </Banner>
  )
}

export default RemedialsReviewEntry

const Banner = styled.button`
  font: inherit;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  padding: 14px 16px;
  margin-bottom: 18px;
  background: #fffaf3;
  border: 1px solid #f3d9b5;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  &:hover { background: #fff4e6; border-color: #e9c391; }
`

const IconTile = styled.span`
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fdecd2;
  color: #c2410c;
`

const Text = styled.span`
  flex: 1 1 auto;
  min-width: 0;
`

const Title = styled.span`
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #12132e;
`

const Sub = styled.span`
  display: block;
  font-size: 13px;
  color: #6e6e78;
  margin-top: 2px;
`

const Go = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #c2410c;
`
